import { ValueFormatterParams } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { StatusType } from "../components/Status";

export interface GridHandle {
  getFilters: () => any;
  refresh: () => void;
  api?: any; // To allow direct access to ag-grid api if needed
}

export interface GridProps {
  columns: ColumnDef[];
  pagination: boolean;
  rowSelection?: RowSelection;
  path: string;
  selectedRows?: any[];
  setSelectedRows?: (rows: any[]) => void;
  onUpdate?: (data: any) => void;
  onDelete?: (data: any) => void;
  onCreate?: () => void;
  onView?: (data: any) => void;
  onHistory?: (data: any) => void;
  // showCrudButtons: boolean;
  // customButtons?: CustomButtons[];
  filters: Filter[];
  customFilters?: any;
  isModal?: boolean;
  setRowData?: (rows: any[]) => void;
  perPage?: number;
  orders?: Order[];
  status: StatusType[];
  isShowStatus?: boolean;
  customButtons?: CustomButtons[];
  defaultSortField?: string;
  persistFiltersKey?: string;
  /**
   * Chave de permissão da tela, para telas que não estão nos menus (a chave
   * normalmente é deduzida da rota). Ex.: `permissionKey="guiches"`.
   */
  permissionKey?: string;
  getRowClass?: (data: any) => string;
  getStatusData?: (data: any, statuses: StatusType[]) => StatusType | undefined;
}

export type ColumnDef = {
  field: string;
  fieldName?: string;
  headerName?: string;
  type?: string;
  width?: number;
  checkboxSelection?: boolean;
  editable?: boolean;
  filter?: any;
  filterParams?: any,
  valueFormatter?: (params: ValueFormatterParams) => void;
  valueGetter?: (params: any) => any;
  cellRenderer?: (params: CustomCellRendererProps) => void;
  cellStyle?: any;
  pinned?: string;
  cellDataType?: string;
  flex?: number;
  sortable?: boolean;
}

export type CustomButtons = {
  label: string;
  icon: (data: any) => string;
  status?: number[];
  action: (data: any) => void;
  shouldShow?: (data: any) => boolean;
}

export enum RowSelection {
  MULTIPLE = "multiple",
  SINGLE = "single"
}

export enum SearchOperation {
  EQUAL = "EQUAL",
  MATCH = "MATCH",
  IN = "IN",
  GREATHER_THAN_EQUAL = "GREATER_THAN_EQUAL",
  LESS_THAN_EQUAL = "LESS_THAN_EQUAL",
  NOT_EQUAL = "NOT_EQUAL"
}

export enum Direction {
  ASC = "ASC",
  DESC = "DESC"
}

export type Filter = {
  field: string;
  value: string | boolean | number | string[];
  operation: SearchOperation;
}

export type Order = {
  field: string;
  direction: Direction;
}
